export enum DataFieldSectionType {
    BusinessUnitInfo = 1,
    BusinessUnitLocationAndContacts = 2,
    BusinessUnitViewGeneral = 3,

    UserName = 11,
    UserWorkProfile = 12,
    UserSettings = 13,
    UserPassword = 14,

    Contacts = 21,
    AccountStatus = 22,
    Custom = 23,
}
